




























































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { BasicSelect } from 'vue-search-select';
import {
  Component, PropSync,
  Prop, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DetailedUserData } from '@/store/users/types';
import { DetailedUser } from '@/auth/auth0Types';
import {
  AuthUserRoles,
  getRoleGuidString,
} from '@/auth/roles';
import IntegrityTable, { FillFunctionContainer } from '@/components/IntegrityTable/IntegrityTable.vue';
import IntegrityDelete from '@/components/IntegrityDelete/IntegrityDelete.vue';
import { UserPermission } from '@/store/userpermissions/types';
import { uuid } from 'vue-uuid';
import { CustomerData } from '@/store/customers/types';
import { OrganizationData } from '@/store/organizations/types';
import ProjectList from './ProjectList.vue';
import AdminPanelMixin, { ADMIN_CAN_MANAGE_KEY, EditUserData, UserTableData } from '../AdminPanelMixin.vue';

const projectModule = namespace('project');

// eslint-disable-next-line no-shadow
export enum UserCondition {
  INACTIVE = 'Inactive',
  PENDING = 'Pending',
  ACTIVE = 'Active',
}

@Component({
  components: {
    BasicSelect,
    IntegrityTable,
    IntegrityDelete,
    ProjectList,
  },
})
export default class ManageUsers extends AdminPanelMixin {
  @Prop() readonly search: string;

  @PropSync('selectedItems') synchedSelectedItems: Array<UserTableData>;

  @PropSync('userData') synchedUserData: Array<UserTableData>;

  @Prop() userDataFiltered: Array<UserTableData>;

  selectedTab = 0;

  isExpanded = [];

  expanded = [];

  expandedUserData: EditUserData = null;

  showSnackbar = false as boolean;

  snackbarColor = '' as string;

  snackbarMessage = '' as string;

  applyDark = false;

  rolesInfo: Array<{id: string, name: string}> = [];

  inTimeout = true;

  lastUpdateKey = '';

  allHeaders = [
    {
      text: 'Users',
      value: 'fullName',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Email',
      value: 'filledEmail',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Role',
      value: 'role',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Organization',
      value: 'organizationName',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Customer(s)',
      value: 'customerNames',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Last Active',
      value: 'filledLastActive',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Status',
      value: 'userStatus',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'start',
      class: 'sticky-end',
      cellClass: 'sticky-end',
    },
  ];

  matchFilters = [
    {
      header: 'fullName',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'filledEmail',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'role',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'organizationName',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'customerNames',
      type: 'array',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'filledLastActive',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'userStatus',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'actions',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
  ];

  get fillTableDataFunctions(): FillFunctionContainer {
    const returnValue: FillFunctionContainer = {
      updateKey: uuid.v4(),
      fillFunctions: [
        {
          headerValue: 'guid',
          functionVariables: [],
          fillFunction:
            function fillGuid(
              item: any,
            ): string {
              return item.detailedUserData?.guid;
            },
        },
        {
          headerValue: 'fullName',
          functionVariables: [],
          fillFunction:
            function fillFullName(
              item: any,
            ): string {
              return `${item.detailedUserData.firstname} ${item.detailedUserData.lastname}`;
            },
        },
        {
          headerValue: 'filledEmail',
          functionVariables: [],
          fillFunction: function fillEmail(item: any): string {
            return item.detailedUserData.email;
          },
        },
        {
          headerValue: 'role',
          functionVariables: [AuthUserRoles],
          fillFunction: function fillRoleString(item: UserTableData, authUserRoles: any[]): string {
            const role = `${item?.detailedUserData?.role ?? item?.role}`;
            if (role == null || role === '') {
              return '';
            }
            const roleObj = authUserRoles.find((r) => r.name === role || r.guid === role);
            return roleObj === undefined ? 'ROLE NOT FOUND' : roleObj.name;
          },
        },
        {
          headerValue: 'organizationName',
          functionVariables: [this.organizationDataList],
          fillFunction:
            function findOrganizationFromOrganizationGuid(
              item: any,
              organizationDataList: OrganizationData[],
            ): string {
              if (organizationDataList == null) {
                return '';
              }
              if (item.detailedUserData.organizationGuids == null
              || item.detailedUserData.organizationGuids.length === 0) {
                return '';
              }
              const foundOrganization = organizationDataList.find(
                (org) => org.guid === item.detailedUserData.organizationGuids[0],
              );
              return foundOrganization?.name ?? '';
            },
        },
        {
          headerValue: 'customerNames',
          functionVariables: [this.customerDataList],
          fillFunction:
            function findCustomersFromCustomerGuids(
              item: any,
              customerDataList: CustomerData[],
            ): string[] {
              if (customerDataList == null) {
                return [];
              }
              if (item.detailedUserData.customerGuids == null
              || item.detailedUserData.customerGuids.length === 0) {
                return [];
              }
              const customerNamesList = item.detailedUserData.customerGuids.map(
                (custGuid) => customerDataList.find(
                  (cust) => cust.guid === custGuid,
                )?.name,
              );
              return customerNamesList ?? [];
            },
        },
        {
          headerValue: 'filledLastActive',
          functionVariables: [],
          fillFunction: function getLastActiveString(item: any): string {
            // eslint-disable-next-line no-nested-ternary, no-unreachable
            const user: DetailedUser = item.detailedUserData?.auth0DetailedUser;
            const lastLogin = user != null && user.lastLogin != null ? user.lastLogin : '';
            const currentDate: number = Date.now();
            const userDate = new Date(lastLogin).getTime();
            const dateDifference: Date = new Date(currentDate - userDate);
            const years = dateDifference.getUTCFullYear() - 1970;
            const months = dateDifference.getUTCMonth();
            const days = dateDifference.getUTCDate();

            // eslint-disable-next-line no-restricted-globals
            if (isNaN(years) || isNaN(months) || isNaN(days)) {
              return 'Unknown';
            }

            if (years > 0) {
              return `${years} year${years > 1 ? 's' : ''} ago`;
            }
            if (months > 0) {
              return `${months} month${months > 1 ? 's' : ''} ago`;
            }
            if (days >= 7) {
              const weeks = Math.floor(days / 7);
              return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
            }

            return `${days} day${days > 1 ? 's' : ''} ago`;
          },
        },
        {
          headerValue: 'userStatus',
          functionVariables: [this.allDBUsers],
          fillFunction: this.statusTextFunction,
        },
      ],
    };
    return returnValue;
  }

  /**
   * @returns true if the user has the permission ADMIN_USER_SECTION_DELETEUSER
   */
  get hasPermissionAdminDeleteUser(): boolean {
    return this.hasPermission(UserPermission.ADMIN_USER_SECTION_DELETEUSER);
  }

  /**
   * @returns true if the user has the permission ADMIN_USER_SECTION_RESETUSERPASSWORD
   */
  get hasPermissionAdminResetUserPassword(): boolean {
    return this.hasPermission(UserPermission.ADMIN_USER_SECTION_RESETUSERPASSWORD);
  }

  /**
   * @returns true if the user has the permission ADMIN_USER_SECTION_EDIT_PROJECT_ACCESS_DATES
   */
  get hasPermissionAdminSetDateRangeForActivation(): boolean {
    return this.hasPermission(UserPermission.ADMIN_USER_SECTION_EDIT_PROJECT_ACCESS_DATES);
  }

  get statusTextFunction(): any {
    return function getStatusText(item: any, allDBUsers: DetailedUserData[]): string {
      const userDB = allDBUsers.find((u) => u.useridentity === item?.detailedUser?.userId);
      if (!item.detailedUser || item.detailedUser.userId === null || !userDB?.isActive) {
        return 'Inactive';
      } if (item.detailedUserData.auth0DetailedUser.lastLogin === null) {
        return 'Pending';
      }
      return 'Active';
    };
  }

  get allDBUsers(): DetailedUserData[] {
    if (this.allUsers && this.inactiveDetailedUserData) {
      return [...this.allUsers, ...this.inactiveDetailedUserData];
    }
    return this.allUsers;
  }

  getStatusColor(user: DetailedUser): string {
    switch (this.getUserCondition(user)) {
      case UserCondition.INACTIVE: return '#FF000033';
      case UserCondition.PENDING: return '#0C659933';
      case UserCondition.ACTIVE: return '#00800033';
      default: return '';
    }
  }

  getUserCondition(detailedUser: DetailedUser): UserCondition {
    const userDB = this.allDBUsers.find((u) => u.useridentity === detailedUser?.userId);
    if (!detailedUser || detailedUser.userId === null || !userDB?.isActive) {
      return UserCondition.INACTIVE;
    }
    if (detailedUser.lastLogin === '') {
      return UserCondition.PENDING;
    }
    return UserCondition.ACTIVE;
  }

  getUserData(user: DetailedUserData,
    isRedzoneOrgMember: boolean,
    visibleRoles: string[]): UserTableData {
    const info = user.auth0DetailedUser;

    if ((user == null || (user.role === undefined && user.userRoles.length === 0))) {
      return {
        role: null,
        auth0Id: null,
        detailedUserData: user,
        detailedUser: null,
        isExpanded: false,
        visible: false,
        resetDialog: false,
      };
    }

    let visible = true;

    const roleName = getRoleGuidString(user.role);
    // check if current user can view user's role
    // Ignore if redzone customer
    if (!isRedzoneOrgMember
          && user.role.length > 0
          && !visibleRoles.includes(roleName)) {
      visible = false;
    }

    return {
      role: roleName,
      auth0Id: user.useridentity,
      detailedUserData: user,
      detailedUser: info,
      isExpanded: false,
      visible,
      resetDialog: false,
    };
  }

  async getUserProjectsData(user: UserTableData): Promise<void> {
    await this.fetchSelectedUserData(user.detailedUserData.guid);
    const foundUser = { ...this.selectedUserData };
    if (!foundUser) {
      this.$router.push({
        name: 'Error',
        params: {
          catchAll: 'Error',
          message:
          `User does not exist with id '${user.detailedUserData.guid}'.`,
        },
      });
    }
    this.expandedUserData = {
      detailedUserData: foundUser,
      auth0Id: foundUser.useridentity,
    };
  }

  // @Watch('selectedItems')
  // async onSelectedItemsChange(): Promise<void> {
  //   if (this.synchedSelectedItems[0]) {
  //     this.canManage = await this.getCanManage(this.synchedSelectedItems[0].role);
  //   }
  // }

  @Watch('expanded')
  async onExpandedChange(): Promise<void> {
    if (this.expanded.length > 0) {
      await this.getUserProjectsData(this.expanded[0]);
    }
  }

  /**
   * @description Used to update the data in the users table.
   * In the Admin mixin, you can call updateAllManagedUsers() from anywhere to update this.
   * That is what the @Watch('updateUserKey') is here for.
   */
  @Watch('updateUserKey')
  async updateAllUsers(): Promise<void> {
    const scopedLastUpdateKey = uuid.v4();
    this.lastUpdateKey = scopedLastUpdateKey;
    this.inTimeout = true;
    this.synchedUserData = [];
    const initPromises = [];
    initPromises.push(this.fetchAllDetailedUserData());
    await Promise.all(initPromises);
    const visibleRoles = this.roleIdFromPermissions(
      this.userPermissions.filter((perm) => perm.includes(ADMIN_CAN_MANAGE_KEY)),
    );
    setTimeout(() => {
      if (this.lastUpdateKey !== scopedLastUpdateKey) {
        return;
      }
      const isRedzoneOrgMember = this.isUserRedzoneOrganizationMember();

      const filteredUsers = this.deepCopyFunction(this.allDBUsers);
      filteredUsers.forEach(async (user) => {
        this.synchedUserData.push(
          this.getUserData(user, isRedzoneOrgMember, visibleRoles),
        );
      });

      this.inTimeout = false;
    }, 1000);
  }

  async mounted(): Promise<void> {
    this.fetchAllProjectsData();
    this.updateAllUsers();
    this.$root.$on('clearUserTableFilters', () => {
      (this.$refs.usersTable as IntegrityTable).clearAllMatchFilters();
    });
  }

  async deleteUser(userData: any): Promise<boolean> {
    const user = userData.detailedUserData;
    try {
      const auth0UserId = user.useridentity;

      const auth0UserDeleted = await this.$auth.deleteUser(auth0UserId);
      await this.deleteUserAction(user.guid);
      if (!auth0UserDeleted) {
        return false;
      }
    } catch (e) {
      return false;
    }
    // eslint-disable-next-line no-param-reassign
    userData.visible = false;
    // eslint-disable-next-line no-param-reassign
    userData.detailedUserData.isExpanded = false;
    this.$forceUpdate();
    return true;
  }

  deleteUserInterface(guid: string): void {
    this.userDataFiltered.find(
      (user) => user.detailedUserData.guid === guid,
    ).visible = false;
  }

  editPage(userGuid: any): void {
    const user = this.userDataFiltered.find((u) => u.guid === userGuid);
    window.location.href = this.$router.resolve({
      name: 'editUser',
      params: { id: user.detailedUserData.guid },
    }).href;
  }

  uniqueValues(value, index, arr) {
    return arr.indexOf(value) === index;
  }

  resetPassword(userGuid: string): void {
    const user = this.userDataFiltered.find((u) => u.guid === userGuid);
    const { email } = user.detailedUserData;

    this.$auth.sendPasswordReset(email);
    this.snackbarColor = 'green';
    this.snackbarMessage = 'Reset Password E-Mail Sent Successfully';
    this.showSnackbar = true;
  }

  resetPasswordDialog(item: any): void {
    const dialogState = this.userDataFiltered.find((u) => u.guid === item.guid).resetDialog;
    this.userDataFiltered.find((u) => u.guid === item.guid).resetDialog = !dialogState;
  }

  deepCopyFunction(inObject): any {
    let outObject;
    let value;
    let key;

    if (typeof inObject !== 'object' || inObject === null) {
      return inObject; // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    // eslint-disable-next-line prefer-const
    outObject = Array.isArray(inObject) ? [] : {};

    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (key in inObject) {
      value = inObject[key];

      // Recursively (deep) copy for nested objects, including arrays
      outObject[key] = this.deepCopyFunction(value);
    }

    return outObject;
  }
}
